/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bid-quote': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.802 1.965a.5.5 0 0 0-.499-.5H.5l-.09.008a.5.5 0 0 0 .09.992h2.174a.5.5 0 0 0 .025.155C3.138 3.98 2.499 4.919.574 5.57a.5.5 0 0 0-.142.872l2.62 1.99.077.048a.498.498 0 0 0 .623-.145l.047-.076a.5.5 0 0 0-.144-.624l-1.92-1.458.238-.118c1.55-.823 2.16-2.045 1.72-3.595h1.61l.09-.008a.5.5 0 0 0 .41-.492zm3.7 2.693a.5.5 0 0 1 .089.992l-.09.008H8.153v1.348a.5.5 0 0 1-.992.09l-.008-.09V5.658H5.805a.5.5 0 0 1-.09-.992l.09-.008h1.348V3.31a.5.5 0 0 1 .992-.09l.008.09v1.348h1.348z" _fill="#E48352"/>'
  }
})
